/* eslint-disable max-len */
import { colors } from '../../../../../packages/colors';
import { makeStyles } from '@mui/styles';

const commonText = {
  fontFamily: 'Roboto-Regular',
  color: '#30344D',
};
export const desText = {
  fontFamily: 'Roboto-Regular',
  color: '#646c73',
  fontSize: 20,
  fontWeight: '100',
};
export const useStyles = makeStyles({
  badge: {
    fontSize: 12,
    height: 18,
    lineHeight: '16px',
    '& path': {
      fill: colors.secondary500,
    },
  },
  container: {
    height: 'calc(100vh - 79px)',
    flex: 1,
    position: 'relative',
    zIndex: 1,
    backgroundColor: colors.white,
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    display: 'flex',
    flexDirection: 'column',
  },
  redIcon: {
    color: colors.destructive500,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    position: 'relative',
  },
  label: {
    fontSize: 16,
    lineHeight: '24px',
    margin: 0,
  },
  header: {
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  infoKey: {
    fontSize: 14,
    lineHeight: '20px',
    display: 'block',
    color: colors.neutral900,
    margin: 0,
  },
  infoValue: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 500,
    color: colors.neutral600,
  },
  infoValueNoData: {
    fontWeight: 400,
    color: colors.neutral700,
  },
  title: {
    fontSize: 22,
    lineHeight: '28px',
    margin: 0,
    fontWeight: '600',
    letterSpacing: '-0.22px',
  },
  additionalNotesTitle: {
    fontSize: 14,
    lineHeight: '20px',
    marginTop: 20,
  },
  subtitle: {
    fontSize: 16,
    lineHeight: '24px',
    margin: 0,
    fontWeight: '500',
    color: colors.neutral600,
  },
  responderType: {
    fontSize: 14,
    lineHeight: '20px',
    color: colors.textSecondary,
    margin: 0,
  },
  body: {
    padding: '32px',
    backgroundColor: colors.white,
    overflowY: 'auto',
    flexGrow: 1,
    gap: '32px',
    display: 'flex',
    flexDirection: 'column',
  },
  exBody: {
    '& h1': {
      fontFamily: 'Source Serif Pro',
      fontWeight: 600,
      fontSize: 40,
      lineHeight: '48px',
      color: colors.neutral900,
      paddingBottom: 24,
    },
    '& h2': {
      fontFamily: 'Source Serif Pro',
      fontWeight: 600,
      fontSize: 36,
      lineHeight: '44px',
      color: colors.neutral900,
      paddingBottom: 24,
    },
    '& h3': {
      fontFamily: 'Source Serif Pro',
      fontWeight: 600,
      fontSize: 32,
      lineHeight: '40px',
      color: colors.neutral900,
      paddingBottom: 24,
    },
    '& p': {
      fontWeight: 400,
      fontSize: 20,
      lineHeight: '28px',
      color: colors.neutral700,
    },
    '& ul': {
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '28px',
      color: colors.neutral700,
    },
    '& a': {
      fontWeight: 400,
      fontSize: 20,
      lineHeight: '28px',
      color: '#0001EE',
    },
    '& img': {
      borderRadius: 16,
    },
  },
  questionsBox: {},
  useBtn: {
    padding: '0px 16px !important',
    maxHeight: '40px !important',
    minWidth: '59px !important',
  },
  questionsList: {
    gap: '16px',
    display: 'flex',
    flexDirection: 'column',
  },
  questionsHeading: {
    fontSize: 16,
    lineHeight: '24px',
    margin: 0,
    color: colors.neutral900,
  },
  questionsText: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 500,
    color: colors.neutral900,
  },
  choicesText: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
    color: colors.neutral700,
  },
  pointer: {
    cursor: 'pointer',
  },
  addPersonalNote: {
    paddingTop: 12,
    '& svg': {
      marginRight: 8,
    },
  },
  footer: {
    bottom: 0,
    width: '100%',
    maxHeight: '80px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTop: `1px solid ${colors.neutral100}`,
    padding: 16,
    paddingLeft: 24,
  },
  nextBtn: {
    color: colors.white,
    '&:hover': {
      backgroundColor: colors.primary600,
      color: colors.white,
    },
    height: 48,
  },
  changeButton: {
    background: colors.white,
    border: `1px solid ${colors.primary300}`,
    color: colors.primary600,
    '&:hover': {
      opacity: 1,
    },
  },
  previousBtn: {
    gap: 12,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '20px',
  },
  previousResponseBox: {
    padding: '16px',
    borderTop: `1px solid ${colors.neutral100}`,
  },
  aiFeedbackBox: {
    padding: 16,
    borderTop: `1px solid ${colors.neutral100}`,
    display: 'flex',
    justifyContent: 'space-between',
  },
  aiBtn: {
    height: 40,
    color: colors.neutral800,
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 700,
  },
  prevText: {
    fontFamily: 'Manrope',
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.neutral600,
  },
  prevResponseItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '24px',
  },
  prevResponseValue: {
    fontFamily: 'Manrope',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    maxHeight: '40px',
    overflow: 'hidden',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      borderRadius: '8px',
    },
  },
  noMatchIcon: {
    color: '#dd2121',
    fontSize: 24,
    borderRadius: 25,
    boxShadow: '0px 0px 1px 7px #fee3e3',
    marginRight: '15px',
  },
  fullMatchIcon: {
    color: '#218d27',
    fontSize: 24,
    borderRadius: 25,
    boxShadow: '0px 0px 1px 7px #e9f9ea',
    backgroundColor: '#e9f9ea',
    marginRight: '15px',
  },
  resolvedIcon: {
    color: '#0374DD',
    fontSize: 24,
    borderRadius: 25,
    boxShadow: '0px 0px 1px 7px #E3F1FF',
    backgroundColor: '#E3F1FF',
    marginRight: '15px',
  },
  partialMatchIcon: {
    color: '#de8618',
    fontSize: 24,
    borderRadius: 25,
    boxShadow: '0px 0px 1px 7px #fef3c8',
    marginRight: '15px',
  },
  useText: {
    fontFamily: 'Manrope',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
  },
  heading1: {
    ...commonText,
    fontFamily: 'Roboto-Bold',
    fontSize: 32,
    fontWeight: '700',
  },
  heading2: {
    ...commonText,
    fontSize: 24,
    fontFamily: 'Roboto-Bold',
    fontWeight: '700',
  },
  heading3: {
    ...commonText,
    fontSize: 18,
    fontFamily: 'Roboto-Bold',
    fontWeight: '700',
  },
  heading4: {
    ...commonText,
    fontSize: 16,
    fontFamily: 'Roboto-Bold',
    fontWeight: '600',
  },
  heading5: {
    ...commonText,
    fontSize: 14,
    fontFamily: 'Roboto-Bold',
    fontWeight: '600',
  },
  heading6: {
    ...commonText,
    fontSize: 11,
    fontFamily: 'Roboto-Bold',
    fontWeight: '600',
  },
  linkText: {
    ...desText,
    textDecorationLine: 'underline',
    fontStyle: 'italic',
    color: '#4FACFE',
  },
  iconContainer: {
    width: '44px',
    height: '44px',
    padding: '12px',
    gap: '8px',
    borderRadius: '6px',
  },
  dctBlock: { borderTop: `1px solid ${colors.neutral200}`, paddingTop: '2rem' },
});
